<template>
  <div>
    <!-- 抽屉 报价单详情   -->
    <el-drawer class="el_drawer"
      :visible.sync="show"
      :with-header="false"
      :size="size"
      :destroy-on-close="true"
	  :modal="false"
      :before-close="handleClose"
    >
      <!--  -->
      <div class="newdrawer_box" v-loading="isloading">
        <div class="newdrawer_content">
          <div class="newdrawer_head">
            <div class="detail-head">
              <div class="detail-head_left">
                <!-- <span v-show="drawer_info.state === 0">未成交</span>
            <span v-show="drawer_info.state === 1">已成交</span> -->
              </div>
              <div class="detail-head_right" v-show="is_recycle">
                <el-tooltip content="恢复" placement="bottom" effect="light">
                  <el-button
                    class="drawer_btn"
                    icon="el-icon-edit"
                    @click="head_btnClick(1)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  content="彻底删除"
                  placement="bottom"
                  effect="light"
                >
                  <el-button
                    class="drawer_btn"
                    icon="el-icon-suitcase"
                    @click="head_btnClick(2)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="bottom" effect="light">
                  <el-button
                    class="drawer_btn"
                    icon="el-icon-edit-outline"
                    @click="head_btnClick(3)"
                  ></el-button>
                </el-tooltip>
              </div>
              <div class="detail-head_right" v-show="!is_recycle">
                <el-tooltip
                  content="新增跟进"
                  placement="bottom"
                  effect="light"
                >
                  <el-button
                    class="drawer_btn"
                    icon="el-icon-edit"
                    @click="head_btnClick(1)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip
                  content="添加订单"
                  placement="bottom"
                  effect="light"
                >
                  <el-button
                    class="drawer_btn"
                    icon="el-icon-suitcase"
                    @click="head_btnClick(2)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="编辑" placement="bottom" effect="light">
                  <el-button
                    class="drawer_btn"
                    icon="el-icon-edit-outline"
                    @click="head_btnClick(3)"
                  ></el-button>
                </el-tooltip>
                <el-dropdown>
                  <el-button
                    type="text"
                    class="drawer_btn-more"
                    icon="el-icon-more"
                    style="margin: 0"
                  ></el-button>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item
                      :command="1"
                      @click.native="switchState(1)"
                    >
                      转让报价单
                    </el-dropdown-item>
                    <el-dropdown-item
                      :command="2"
                      @click.native="switchState(2)"
                    >
                      添加协作人
                    </el-dropdown-item>
                    <el-dropdown-item
                      :command="3"
                      @click.native="switchState(3)"
                    >
                      删除报价单
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <div class="detail-top">
              <!-- <div class="detail-top_left" v-if="curfield_power.head_image != 3">
            <img
                :src="drawer_info.head_image"
                v-if="drawer_info.head_image"
              />
              <img v-else src="~assets/img/def_icon.png" />
          </div> -->
              <div class="detail-top_right">
                <div
                  class="detail-top_up"
                  v-clipboard:copy="DetailsData.bd_code"
                  v-clipboard:success="copy_success"
                  :title="'点击复制报价单编号:' + DetailsData.bd_code"
                >
                  报价单编号：{{ DetailsData.bd_code || "" }}
                </div>
                <div class="detail-top_down">
                  <div class="conent1">
                    <span v-if="DetailsData.member">
                      {{ DetailsData.member.name || "暂无" }}
                    </span>
                  </div>
                  <div class="conent2">
                    创建于{{ DetailsData.create_time || "" }},
                  </div>
                  <div class="conent3">
                    {{
                      DetailsData.follow_time
                        ? "最近更新于" + DetailsData.follow_time
                        : "暂无更新"
                    }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="newdrawer_body">
            <div class="detail_content">
              <div
                class="detail_content_left"
                :style="{ height: windowHeight - 200 + 'px' }"
              >
                <div class="content-container">
                  <div class="container_tabs">
                    <el-tabs class="eltabs" v-model="activeName">
                      <el-tab-pane label="信息" name="1">
                        <div>
                          <div class="eltabs_info">
                            <template v-for="item1 in infolist">
                              <template v-for="(item2) in item1.list">
                                <div class="eltabs_info_title">
                                  <div class="eltabs_info_label">
                                    {{ item2.title || "" }}
                                  </div>
                                  <div class="eltabs_info_text">
                                    {{ item2.text || "暂无" }}
                                  </div>
                                </div>
                              </template>
                            </template>
                          </div>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane label="详细" name="2">
                        <div>
                          <div class="eltabs_minute">
                            <newdetailedbox
                              :fieldlist="essentialInfo"
                              v-if="essentialInfo.length"
                              :createlist="Group_show"
                            ></newdetailedbox>
                            <div class="form_boxs">
                              <label class="tit_left"
                                ><i
                                  class="el-icon-collection-tag"
                                  style="
                                    font-size: 12px;
                                    color: #2b75ebff;
                                    margin-right: 8px;
                                  "
                                ></i
                                >费用及收款</label
                              >
                              <div class="form_item_left">
                                <template v-for="(item, index) in Expenseslist">
                                  <div class="items">
                                    <div class="tit">
                                      {{ item.title || "" }}
                                    </div>
                                    <el-input
                                      :disabled="true"
                                      v-model="item.value"
                                      placeholder="请输入内容"
                                      class="input_w460"
                                    >
                                    </el-input>
                                  </div>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div></div>
                </div>
                <div class="content-container_bottom">
                  <div class="container_bottom_tabs">
                    <el-tabs class="bottom_eltabs" v-model="activeLog">
                      <el-tab-pane label="操作日志" name="5">
                        <div>
                          <div class="eltabs_log">
                            <div
                              class="eltabs_log_item"
                              v-for="logitem in custLogList"
                            >
                              <div class="cell-of-icon">
                                <i class="el-icon-notebook-2"></i>
                              </div>
                              <div class="cell-of-user">
                                {{ logitem.member_name }}
                              </div>
                              <div class="cell-of-content">
                                <div
                                  class="cell-of-text"
                                  v-for="value in logitem.children"
                                >
                                  <template v-if="value.field">
                                    {{ value.field || "" }}
                                    <template v-if="value.before">
                                      从
                                      <span>
                                        {{ value.before || "" }}
                                      </span>
                                    </template>
                                    修改为
                                    <span>
                                      {{ value.after || "空" }}
                                    </span>
                                  </template>
                                  <template v-else>
                                    {{ value.content || "" }}
                                  </template>
                                </div>
                              </div>
                              <span class="cell-of-time">{{
                                logitem.create_time
                              }}</span>
                            </div>
                          </div>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane> </el-tab-pane>
                    </el-tabs>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="drawer_box FlexBox FlexDirColumn" v-loading="isloading">
				<div class="drawer_head" ref="getheight">
					<div class="head_info FlexBetween">
						<div class="leftb Flexalign">
							<div class="info_name">
								<div class="name Singlerow"  style="cursor: pointer;"
								 v-clipboard:copy="DetailsData.bd_code" v-clipboard:success="copy_success"
								:title="'点击复制报价单编号:'+DetailsData.bd_code">
									报价单编号：{{DetailsData.bd_code || ''}}
								</div>
							</div>
						</div>
						<div class="rightb Flexalign" v-show="!is_recycle">
							<div class="drawer_btn style1" @click="head_btnClick(1)">
								新增跟进
							</div>
							<div class="drawer_btn style1" @click="head_btnClick(2)">
								添加订单
							</div>
							<div class="drawer_btn style1" @click="head_btnClick(3)">
								编辑
							</div>
							<el-dropdown>
								<div class="drawer_btn style2">
									<i class="el-icon-more"></i>
								</div>
								<el-dropdown-menu slot="dropdown">

									<el-dropdown-item :command="1" @click.native="switchState(1)">
										转让报价单
									</el-dropdown-item>
									<el-dropdown-item :command="2" @click.native="switchState(2)">
										添加协作人
									</el-dropdown-item>
									<el-dropdown-item :command="3" @click.native="switchState(3)" >
										删除报价单
									</el-dropdown-item>

								</el-dropdown-menu>
							</el-dropdown>
						</div>

						<div class="rightb Flexalign" v-show="is_recycle">
							<div class="drawer_btn style1" @click="head_btnClick(1)">
								恢复
							</div>
							<div class="drawer_btn style1" @click="head_btnClick(2)">
								彻底删除
							</div>
							<div class="drawer_btn style1" @click="head_btnClick(3)">
								编辑
							</div>
						</div>
					</div>
					<div class="headinfo_list">
						<table border="0" cellpadding="0" cellspacing="0">
							<tr v-for="(item1, index1) in infolist">
								<td v-for="(item2, index2) in item1.list">
									<div class="info_item">
										<div class="tit">
											{{item2.title || ''}}
										</div>
										<div class="txt Singlerow" :title="item2.text">
											{{item2.text || '暂无'}}
										</div>
									</div>
								</td>
							</tr>
						</table>
					</div>
				</div>
				<div class="drawer_body">
					<el-tabs v-model="activeName">
						<el-tab-pane label="跟进" name="1">
							<div class="drawer_row" :style="row_height" v-if="show">
								<followupbox :ispowerEdit="is_powerEdit" :ispowerDel="is_powerDel" ref="sfollow"
									:show="activeName == '1'" :quotation_id="quotation_id"></followupbox>
							</div>
						</el-tab-pane>
						<el-tab-pane label="详细" name="2">
							<div class="drawer_row" :style="row_height">
								<div class="detail_title">
									基础信息 
								</div>
								<div class="detail_content">
									<fieldshow :types="foundation_id" :fieldlist="essentialInfo" :style2="true"></fieldshow>
								</div>
								<div class="detail_title" style="padding-top: 30px;">
									费用及收款
								</div>
								<div class="detail_content">
									<div class="form_content2">
										<div class="form_items Flexalign" v-for="(item, index) in Expenseslist">
											<div class="tit">
												{{item.title || ''}}
											</div>
											<el-input clearable :disabled="true" show-word-limit v-model="item.value"
												placeholder="请输入内容">
											</el-input>
										</div>
									</div>
								</div>

							</div>
						</el-tab-pane>
						<el-tab-pane label="产品" name="3">
							<div class="drawer_row " :style="row_height" v-if="show">
								<productinfor ref="productiref" 
								 :classtype="2"
								@completeset="completeset"
								:goodslist="quotation_goods" :isShow="true"></productinfor>
							</div>
						</el-tab-pane>
						<el-tab-pane label="附件" name="4">
							<div class="drawer_row " :style="row_height" style="padding-top: 0;">
								<enclofile :btnshow="false" :isrevise="false" :enclist.sync="enclist"></enclofile>
							</div>
						</el-tab-pane>
					</el-tabs>
				</div>
			</div> -->
    </el-drawer>
    <!--  -->

    <!-- 写跟进 -->

    <!-- <writefollow :customer_id="customer_id" :quotation_id="quotation_id" :contact_id="contact_id"
			:show.sync="write_show" @addsuccess="addsuccess"></writefollow> -->

    <writefollow
      :show.sync="write_show"
      @addsuccess="addsuccess"
      :customer_obj="customer_obj"
      :quotation_obj="quotation_obj"
    ></writefollow>
    <!--  -->
  </div>
</template>

<script>
import followupbox from "components/content/addproduct/followupbox";
import relationchance from "components/content/addproduct/relationchance";
import fieldshow from "./detail/fieldshow.vue";
// import productinfor from "./detail/productinfor.vue";
import newdetailedbox from "components/content/addproduct/newdetailedbox";
import productinfor from "../../components/productinfor.vue";

import enclofile from "../../components/enclofile.vue";
import writefollow from "@/components/integrated/writefollow.vue";

import {
  // 报价单字段分类
  get_quotation_group_list,
  // 报价单字段
  get_quotation_field_list,
  get_quotation_details,
  get_quotation_compute,
  recycle_quotation,
} from "network/hk_quotation";
import { fn_newfield } from "network/hk_operset";
import {
  handlereq,
  alertMess,
  retujudpower,
  retupower,
} from "network/kh_public";
var that;
export default {
  name: "popdrawer",
  components: {
    followupbox,
    fieldshow,
    productinfor,
    enclofile,
    relationchance,
    writefollow,
    newdetailedbox,
  },
  props: {
    quotation_id: {
      type: Number,
      default: 0,
    },
    show: {
      type: Boolean,
      default: false,
    },
    is_recycle: {
      type: Number,
      default: 0,
    },
    size: {
      type: Number,
      default: 774,
    },

    is_powerEdit: {
      type: Boolean,
      default: true,
    },
    is_powerDel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      quotation_obj: {
        id: "",
        name: "",
      },
      customer_obj: {
        id: "",
        name: "",
      },

      write_show: false,
      customer_id: "",
      contact_id: "",

      DetailsData: "",

      activeName: "0",
      row_height: "",

      isloading: true,

      infolist: [],

      essenSignlist: [],
      ClassInitial: [],
      FieldInitial: [],
      // 基本信息
      essentialInfo: [],

      Expenseslist: [
        {
          title: "整单折扣额：",
          value: "",
        },
        {
          title: "整单折扣率：",
          value: "",
        },
        {
          title: "报价单金额：",
          value: "",
        },
      ],

      enclist: [],

      quotation_goods: [],

      satisfy_goods: "",
      satisfy_returnId: "",
      discount_rate: "",
      discount_amount: "",

      foundation_id: 0,
	  activeLog: "5",
      custLogList: [],
      windowHeight: window.innerHeight,
      Group_show: [
    	{
          name: "基础信息",
          type: 69,
        },
      ],
    };
  },
  created() {
    that = this;
  },
  watch: {
    show() {
      this.activeName = "0";
      this.isloading = true;
      this.quotation_goods = [];
      this.satisfy_goods = "";
      this.satisfy_returnId = "";
      this.discount_rate = "";
      this.discount_amount = "";
      if (this.show) {
        this.getvanhe();
        if (this.quotation_id) {
          this.getDetails();
        }
      }
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    handleResize() {
      this.windowHeight = window.innerHeight;
    },

    copy_success(e) {
      alertMess(`复制成功: ${e.text}`);
    },

    // 新增跟进成功
    addsuccess() {
      this.activeName = "0";
      this.getDetails();
      this.write_show = false;
    },

    completeset() {
      setTimeout(() => {
        this.setComputeSatisfy();
      }, 500);
    },
    setComputeSatisfy() {
      let data = {
        quotation_goods: "",
      };
      if (this.satisfy_goods) {
        data.quotation_goods = this.satisfy_goods;
        if (this.discount_amount) {
          data.discount_amount = this.discount_amount;
        }
        if (this.discount_rate) {
          data.discount_rate = this.discount_rate;
        }
        this.getquotationCompute(data);
      }
    },
    // 获取报价单计算数据
    getquotationCompute(Compute) {
      let infoArrr = [];
      for (let item of Compute.quotation_goods) {
        let newEle = {
          goods_num: item.goods_num,
          goods_price: item.goods_price,
          discount_rate: item.discount_rate,
          vat_rate: item.vat_rate,
        };
        infoArrr.push(newEle);
      }
      let fd = new FormData();
      fd.append("goods_info", JSON.stringify(infoArrr)); // 是	string	产品信息
      if (Compute.discount_amount) {
        fd.append("discount_amount", Compute.discount_amount); // 否	int	折扣额
      }
      if (Compute.discount_rate) {
        fd.append("discount_rate", Compute.discount_rate); //  	否	int	折扣率
      }

      get_quotation_compute(fd).then((res) => {
        if (handlereq(res)) {
          let obj = res.result;
          this.setderCompute(obj);
        }
      });
    },
    setderCompute(obj) {
      if (this.quotation_goods.length) {
        if (this.$refs.productiref) {
          this.$refs.productiref.gnmentcompa(obj);
        }
      }
      // 费用及收款
      if (obj.discount_amount) {
        this.Expenseslist[0].value = obj.discount_amount
          ? "￥" + obj.discount_amount
          : "";
      }
      if (obj.discount_rate) {
        this.Expenseslist[1].value = obj.discount_rate
          ? obj.discount_rate + "%"
          : "";
      }
      this.Expenseslist[2].value = obj.quotation_price
        ? "￥" + obj.quotation_price
        : "";
    },
    // 获取报价单详情
    getDetails() {
      get_quotation_details(this.quotation_id).then((res) => {
        if (handlereq(res)) {
          let obj = res.result;
          this.handle_data(obj);
          this.isloading = false;
          this.activeName = "1";
        }
      });
    },
    findJsonInfo(field_sign) {
      let res = "";
      let index1 = this.quotation_info.findIndex(
        (v) => v.field_sign == field_sign
      );
      if (index1 != -1 && this.quotation_info[index1]) {
        res = this.quotation_info[index1].content || "";
      }
      return res;
    },
    handle_data(obj) {
      // 报价单字段详情， 产品信息， 回款信息
      let {
        quotation_info,
        quotation_goods,

        discount_amount,
        discount_rate,
      } = obj;
      if (quotation_info && typeof quotation_info === "string") {
        let Json_Obj = JSON.parse(quotation_info);
        this.quotation_info = Json_Obj;

        obj.address = "";
        obj.address_txt = "";
        let content = this.findJsonInfo("收货地址");
        if (content) {
          obj.address = content;
          obj.address_txt = `${content.area_txt1 || ""}${
            content.area_txt2 || ""
          }${content.area_txt3 || ""}${content.address || ""}`;
        }
        obj.remarks = this.findJsonInfo("报价单备注");
        this.enclist = this.findJsonInfo("上传附件") || [];
      }
      // 产品信息列表
      this.quotation_goods = obj.quotation_goods || [];
      //
      this.satisfy_goods = quotation_goods || "";

      // 费用及收款
      if (discount_amount) {
        this.Expenseslist[0].value = "￥" + obj.discount_amount;
        this.discount_amount = discount_amount;
      }
      if (discount_rate) {
        this.Expenseslist[1].value = obj.discount_rate + "%";
        this.discount_rate = discount_rate;
      }
      // 写跟进需要的数据
      this.customer_id = obj.customer_id || "";
      this.contact_id = obj.contact_id || "";
      this.customer_obj = {
        id: obj.customer_id || "",
        name: obj.customer ? obj.customer.name1 : "",
      };

      this.quotation_obj = {
        id: this.quotation_id,
        name: obj.bd_code,
      };
      // 基本信息字段配置
      let obessen = [
        {
          field_sign: "报价单编号",
          field_type: 1,
          content: obj.bd_code || "",
        },
        {
          field_sign: "报价日期",
          field_type: 1,
          content: obj.quotation_time ? obj.quotation_time.slice(0, 10) : "",
        },
        {
          field_sign: "报价单状态",
          field_type: 1,
          content: obj.status ? obj.status.name : "",
        },
        {
          field_sign: "客户",
          field_type: 1,
          content: obj.customer ? obj.customer.name1 : "",
        },
        {
          field_sign: "收货地址",
          field_type: 2,
          content: obj.address_txt ? obj.address_txt : "",
        },
        {
          field_sign: "联系人",
          field_type: 1,
          content: obj.contact ? obj.contact.name1 : "",
        },
        {
          field_sign: "负责人",
          field_type: 1,
          content: obj.member ? obj.member.name : "",
        },
        {
          field_sign: "协同人",
          field_type: 1,
          content: "",
        },
        {
          field_sign: "报价单备注",
          field_type: 2,
          maxLength: 150,
          content: obj.remarks || "",
        },
      ];
      //
      let infoshow = [
        {
          list: [
            {
              title: "客户",
              text: obj.customer ? obj.customer.name1 : "",
            },
            {
              title: "报价日期",
              text: obj.quotation_time ? obj.quotation_time.slice(0, 10) : "",
            },
            {
              title: "报价单状态",
              text: obj.status ? obj.status.name : "",
            },
            {
              title: "收货地址",
              text: obj.address_txt ? obj.address_txt : "",
            },
          ],
        },
        {
          list: [
            {
              title: "创建人",
              text: obj.creator_member ? obj.creator_member.name : "",
            },
            {
              title: "负责人",
              text: obj.member ? obj.member.name : "",
            },
            {
              title: "协同人",
              text: "",
            },
            {
              title: "最后跟进时间",
              text: obj.follow_time ? obj.follow_time : "",
            },
          ],
        },
      ];
      let textArr = [];
      if (obj.assistant_member && obj.assistant_member.length) {
        for (let item of obj.assistant_member) {
          if (item.member_id) {
            textArr.push(item.name);
          }
        }
      }
      if (textArr.length) {
        infoshow[1].list[2].text = textArr.join(",");
        obessen[7].content = textArr.join(",");
      }
      this.infolist = infoshow;
      this.essenSignlist = obessen;
      this.DetailsData = JSON.parse(JSON.stringify(obj));

      this.getFieldClass();
    },

    // -----------------------
    // 获取字段分类
    getFieldClass(flag) {
      get_quotation_group_list(999, 1).then((res) => {
        if (handlereq(res)) {
          let obj = res.result.data;
          if (obj && obj.length) {
            for (let item of obj) {
              item.type = item.group_id;
              item.fieldnewArr = [];
            }
            this.ClassInitial = obj;
            this.getConfigList();
          }
        }
      });
    },

    fn_findid(id) {
      let res = "";
      if (this.quotation_info.length) {
        let index = this.quotation_info.findIndex((v) => v.field_id == id);
        if (index != -1) {
          res = this.quotation_info[index].content;
        }
      }
      return res;
    },
    // 获取字段列表
    getConfigList() {
      get_quotation_field_list(999, 1).then((res) => {
        if (handlereq(res)) {
          let list = res.result.data || [];
          for (let item of list) {
            // 非系统字段基础配置
            fn_newfield(item, false);
            // 设置详情数据的值给字段
            item.content = this.fn_findid(item.id);
            // 是否显示字段
            item.is_show = true;
            // 是否禁用字段
            item.disabled = true;
          }
          // 所有字段信息
          this.FieldInitial = JSON.parse(JSON.stringify(list));
          // 基本信息
          let group_id1 = this.findClassd("基本信息");
          this.foundation_id = group_id1;
          if (group_id1) {
            let newList = list.filter((v) => v.group_id == group_id1);
            this.setFields(newList);
          }
        }
      });
    },
    findClassd(name) {
      let resGroup_id = "";
      let index = this.ClassInitial.findIndex((v) => v.name == name);
      if (index != -1 && this.ClassInitial[index]) {
        resGroup_id = this.ClassInitial[index].group_id;
      }
      return resGroup_id;
    },
    // 设置基础信息的字段
    setFields(newList) {
      let list = JSON.parse(JSON.stringify(newList));
      for (let item of list) {
        // 系统字段
        if (item.is_lock == 1) {
          // 系统字段
          let index1 = this.essenSignlist.findIndex(
            (v) => v.field_sign == item.field_sign
          );
          if (index1 != -1 && this.essenSignlist[index1]) {
            let curobj = this.essenSignlist[index1];
            // 字段类型
            item.field_type = curobj.field_type;
            // 字段内容
            item.content = curobj.content != undefined ? curobj.content : "";
            // 字段下拉选择列表
            item.field_list =
              curobj.field_list != undefined ? curobj.field_list : [];
            // 是否带*
            item.required =
              curobj.required != undefined ? curobj.required : false;
            item.maxLength =
              curobj.maxLength != undefined ? curobj.maxLength : 120;
          }
        }
      }
      // 显示和编辑的字段列表
      this.essentialInfo = list;

      //
    },
    // 恢复
    fn_resume(ids) {
      recycle_quotation(ids, 0).then((res) => {
        if (handlereq(res)) {
          alertMess("恢复成功");
          this.$emit("resume");
        }
      });
    },

    head_btnClick(flag) {
      // is_powerDel quotatlist quotatcreate
      if (flag == 3) {
        // 编辑
        if (retujudpower(this.is_powerEdit)) {
          this.$router.push({
            path: "/operate/quotatlist/quotatcreate",
            query: {
              quotation_id: this.quotation_id,
              is_recycle: this.is_recycle,
            },
          });
        }
      }
      if (this.is_recycle) {
        // 回收站
        if (flag == 1) {
          // 恢复
          if (retujudpower(this.is_powerEdit)) {
            this.fn_resume(this.quotation_id);
          }
        } else if (flag == 2) {
          // 彻底删除

          this.switchState(3);
        }
      } else {
        if (flag == 1) {
          // 新增跟进
          if (retujudpower(this.is_powerEdit)) {
            this.write_show = true;
          }
        } else if (flag == 2) {
          // 转订单
          if (retujudpower(this.is_powerEdit)) {
            this.$router.push({
              // path: '/operate/quotatlist/quotatcreate',
              path: "/operate/orderlist/ordercreate",
              query: {
                quotation_id: this.quotation_id,
                is_recycle: this.is_recycle,
              },
            });
          }
        }
      }
    },
    switchState(flag) {
      let drawer_info = JSON.parse(JSON.stringify(this.DetailsData));
      let data = {
        BatchType: 1,
        drawer_info,
      };
      if (flag == 1) {
        // 转让报价单
        if (retujudpower(this.is_powerEdit)) {
          this.$emit("switchclick", data);
        }
      } else if (flag == 2) {
        // 添加协作人
        if (retujudpower(this.is_powerEdit)) {
          data.BatchType = 2;
          this.$emit("switchclick", data);
        }
      } else if (flag == 3) {
        // 删除报价单
        if (retujudpower(this.is_powerEdit)) {
          let res = {
            quotation_id: this.quotation_id,
            is_recycle: this.is_recycle,
          };
          this.$emit("switchclick", res);
        }
      }
    },

    // 弹出  点击遮罩和 x 关闭弹出
    handleClose(done) {
      this.$emit("update:show", false);
    },
    getvanhe() {
      setTimeout(() => {
        let h1 = document.documentElement.clientHeight;
        let h2 = this.$refs.getheight ? this.$refs.getheight.offsetHeight : 0;
        let num = h1 - h2 - 48;
        let height = `height: ${num}px`;
        this.row_height = height;
      }, 300);
    },
  },
};
</script>

<style scoped lang="scss">
.el_drawer{
	/deep/ .el-drawer__wrapper {
  		padding-top: 60px;
	}
	/deep/ .el-drawer {
		box-shadow: 0 8px 10px rgba(0, 0, 0, 0.2) !important;
		border-top: 1px solid #dadee3;
	}
}

@import "@/assets/css/public.scss";
.form_item_left {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.tit_left {
  color: #2e405e;
  display: block;
  font-size: 16px;
  font-weight: bolder;
  text-transform: none;
  margin-bottom: 19px;
}
.tit {
  color: #2e405e;
  display: block;
  font-size: 14px;
  font-weight: bolder;
  text-transform: none;
  margin-bottom: 5px;
}
.items {
  display: flex;
  flex-direction: column;
  margin-bottom: 13px;
}
.input_w460 {
  width: 460px;
  height: 32px;
}
// @import "../css/order.scss";

// .drawer_body {
//   flex: 1;
//   background-color: #fff;
//   width: 100%;
//   .drawer_row {
//     padding: 29px;
//     width: 100%;
//     height: 100%;
//     overflow: auto;
//     padding-bottom: 0;
//     .detail_content {
//       /deep/ .el-input {
//         min-width: 500px !important;
//         width: 500px !important;
//       }
//     }
//   }

//   .drawer_row.bg1 {
//     background-color: #f7f8f9;
//   }
// }

// .detail_title::before {
//   content: "";
//   display: inline-block;
//   width: 3px;
//   height: 20px;
//   background: rgba(43, 117, 235, 1);
//   margin-right: 10px;
// }

// .detail_title {
//   font-size: 16px;
//   font-weight: 550;
//   color: rgba(56, 56, 56, 1);
//   text-align: left;
//   vertical-align: top;
//   width: 100%;
//   display: flex;
//   align-items: center;
//   margin-bottom: 24px;
// }

// .detail_content {
//   width: 100%;
// }
</style>